<template>
    <Layout>
        <div class="row">
            <div class="col-lg-12">
                <div class="col-xl-8 col-12 px-3 py-3">
                    <div class="d-flex align-items-sm-center align-items-start gap-lg-3 gap-2 flex-column flex-sm-row">
                        <PageHeader title="Customer Details" :items="items" class="poppins fw-normal text-nowrap" />
                    </div>
                </div>

                <div class="card-body table mb-0 d-flex justify-content-center align-items-center" v-if="loading"
                    style="min-height: 200px">
                    <APILoader :loading="loading" class="align-middle text-center" />
                </div>
                <template v-if="user">

                    <div class="card border border-radius-12">
                        <div class="card-body table mb-0">
                            <div class="row gap-2 gap-sm-0">
                                <div class="col-12 col-sm-4 d-flex justify-content-center">
                                    <div
                                        class="d-flex align-items-center gap-2 flex-column flex-xxl-row">
                                        <img :src="user?.avatar
                                            ? user?.avatar
                                            : require('@/assets/images/users/default_user_image.png')" alt="Avatar"
                                            class="user-detail-nav-avatar me-2" @error="handleImageError" />
                                        <h2 class="mb-0 f-20 fw-semibold poppins">
                                            {{ user?.full_name }}
                                        </h2>
                                        <div class="d-flex align-items-center justify-content-center justify-content-xxl-start gap-2">
                                            <span class="badge rounded-pill"
                                                :class="user?.is_active ? 'bg-success' : 'bg-danger'">
                                                {{ user?.is_active ? 'Active' : 'Inactive' }}
                                            </span>
                                            <label class="toggle-switch" v-if="user">
                                                <input type="checkbox" :checked="Boolean(user.is_active)"
                                                    :disabled="statusProcessing" @change="onToggleUserStatus" />
                                                <span class="toggle-slider"></span>
                                            </label>  
                                            <span>#{{ user?.id }}</span>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-12 col-sm-8 d-flex justify-content-end align-items-center">
                                <nav class="w-100 d-flex justify-content-end me-0 me-xl-4">
                                    <div
                                    id="nav-tab"
                                    class="nav nav-tabs my-tabs-red rounded-pill px-0 border-0 row g-2 view-items-grid mb-md-0 mb-2"
                                    >
                                    <div
                                        v-for="tab in tabs"
                                        :key="tab.key"
                                        class="col-12 col-md-6 col-xl-auto d-flex"
                                    >
                                        <button
                                        v-if="!tab.subtabs || !tab.subtabs.length"
                                        type="button"
                                        @click="setActiveTab(tab.key)"
                                        class="nav-link fw-normal roboto border border-1 px-4 dark-grey f-14 w-100 w-xl-auto mb-0"
                                        >
                                        {{ tab.label }}
                                        <i
                                            v-if="tab.key === 'cancel_subscription' && cancelbtnprocessing"
                                            class="fas fa-spinner fa-spin"
                                        ></i>
                                        </button>
                                        <div
                                            v-else
                                            class="btn-group position-relative w-100 w-xl-auto"
                                            >
                                            <button
                                                type="button"
                                                class="nav-link fw-normal roboto border border-1 px-4 dark-grey f-14 dropdown-toggle
                                                    w-100 w-xl-auto text-center d-flex align-items-center justify-content-center"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                {{ tab.label }}
                                            </button>

                                            <ul class="dropdown-menu w-100">
                                                <li
                                                v-for="subtab in tab.subtabs"
                                                :key="`${tab.key}-${subtab.key}`"
                                                >
                                                <button
                                                    type="button"
                                                    class="dropdown-item w-100 px-0 text-center"
                                                    @click="setActiveTab(subtab.key)"
                                                >
                                                    {{ subtab.label }}
                                                    <i
                                                    v-if="subtab.key === 'cancel_subscription' && cancelbtnprocessing"
                                                    class="fas fa-spinner fa-spin ms-2"
                                                    ></i>
                                                </button>
                                                </li>
                                            </ul>
                                            </div>
                                        </div>
                                    </div>
                                </nav>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="card border border-radius-12">
                        <div class="card-body table mb-0">
                        <div class="row mt-2 g-3">
                            <div
                                class="d-flex align-items-sm-center align-items-start gap-lg-3 gap-2 flex-column flex-sm-row">
                                <PageHeader title="Customer Profile" :items="items"
                                    class="poppins fw-normal text-nowrap" />
                            </div>
                            <div class="col-xl-4 col-lg-6 col-12">
                                <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                    <span class="fw-semibold">Email:</span>
                                    <span>{{getSafe(() => user.email ?? 'N/A')}}</span>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-12">
                                <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                    <span class="fw-semibold">Phone:</span>
                                    <span>{{getSafe(() => user.mobile ?? 'N/A')}}</span>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-12">
                                <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                    <span class="fw-semibold">Registered At:</span>
                                    <span>{{getSafe(() => user.created_at_formatted ?? 'N/A')}}</span>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-12">
                                <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                    <span class="fw-semibold">Address:</span>
                                    <span>{{getSafe(() => user.address.address ?? 'N/A')}}</span>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-12">
                                <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                    <span class="fw-semibold">Country:</span>
                                    <span>{{getSafe(() => user.address.country ?? 'N/A')}}</span>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-12">
                                <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                    <span class="fw-semibold">City:</span>
                                    <span>{{getSafe(() => user.address.city ?? 'N/A')}}</span>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-12">
                                <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                    <span class="fw-semibold">State:</span>
                                    <span>{{getSafe(() => user.address.state ?? 'N/A')}}</span>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-12">
                                <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                    <span class="fw-semibold">Zip Code:</span>
                                    <span>{{getSafe(() => user.address.zipcode ?? 'N/A')}}</span>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-12">
                                <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                    <span class="fw-semibold">Stripe Customer:</span>
                                    <span>{{getSafe(() => user.stripe_id ?? 'N/A')}}</span>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-12">
                                <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                    <span class="fw-semibold">Payment Method:</span>
                                    <span>{{getSafe(() => user.pm_type + ' **' + user.pm_last_four ?? 'Not Attached Yet')}}</span>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-12">
                                <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                    <span class="fw-semibold">Invoice Setting:</span>
                                    <span> <template v-if="user.pm_type && user.pm_last_four">Charged
                                            Automatically</template>
                                        <template v-else>Need to add Billing</template> </span>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-12">
                                <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1" v-if="user?.added_by">
                                    <span class="fw-semibold">Added By Admin:</span>
                                    <span>{{getSafe(() => user.added_by.full_name ?? 'N/A')}}</span>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-12">
                                <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1" v-if="user?.added_by && user?.subscriptions[0]?.life_time == 1">
                                    <span class="fw-semibold">Life Time Membership:</span>
                                    <span>Yes</span>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="card border border-radius-12">
                        <div class="card-body table mb-0">
                            <div class="row mt-2 g-3">
                                <div
                                    class="d-flex align-items-sm-center align-items-start gap-lg-3 gap-2 flex-column flex-sm-row">
                                    <PageHeader title="Plan & Access Summary" :items="items"
                                        class="poppins fw-normal text-nowrap" />
                                </div>
                                <div class="col-xl-4 col-lg-6 col-12">
                                    <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                        <span class="fw-semibold">Current Subscription Level:</span>
                                        <span>{{getSafe(() => user?.subscriptions[0]?.subscription_plan?.name ??
                                            'N/A')}}</span>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-12">
                                    <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                        <span class="fw-semibold">Current Subscription Status:</span>
                                        <span class="text-capitalize">{{getSafe(() =>
                                            user?.subscriptions[0]?.stripe_status ??
                                            'N/A')}}</span>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-12" v-if="user?.subscriptions[0]?.trial_ends_at">
                                    <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                        <span class="fw-semibold">One Month Free:</span>
                                        <span class="text-capitalize">Yes</span>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-12" v-if="user?.subscriptions[0]?.trial_ends_at">
                                    <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                        <span class="fw-semibold">Coupan Applied:</span>
                                        <span class="text-capitalize">No</span>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-12" v-if="user?.subscriptions[0]?.trial_ends_at">
                                    <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                        <span class="fw-semibold">Trial End Date:</span>
                                        <span class="text-capitalize">{{ user?.subscriptions[0]?.trial_ends_at_formatted
                                            }}</span>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-12">
                                    <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                        <span class="fw-semibold">Billing Frequency:</span>
                                        <span class="text-capitalize">{{getSafe(() =>
                                            user?.subscriptions[0]?.subscription_plan?.interval ??
                                            'Not Specified')}}</span>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-12">
                                    <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                        <span class="fw-semibold">Subscription Start Date:</span>
                                        <span class="text-capitalize">{{getSafe(() =>
                                            user?.subscriptions[0]?.created_at_formatted ?? 'N/A')}}</span>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-12">
                                    <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                        <span class="fw-semibold">Subscription End Date:</span>
                                        <span class="text-capitalize">{{getSafe(() =>
                                            user?.subscriptions[0]?.subscription_end_date
                                                ? formatDateTime(user.subscriptions[0].subscription_end_date)
                                                : 'N/A'
                                            )}}</span>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-12">
                                    <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                        <span class="fw-semibold">Billing Type:</span>
                                        <span class="text-capitalize">
                                            <template v-if="user.subscriptions?.length == 1">
                                                First Charge
                                            </template>
                                            <template v-if="user.subscriptions?.length > 1">
                                                Renewal
                                            </template>
                                            <template v-if="user.subscriptions?.length <= 0">
                                                Not Subscribed
                                            </template>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-12">
                                    <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                        <span class="fw-semibold">Customer Stripe Balance:</span>
                                        <span class="text-capitalize" v-if="!userBalanceProcessing">{{ user_balance }}</span>
                                        <span class="text-capitalize" v-else><i class='fas fa-spinner fa-spin'></i></span>
                                     </div>
                                </div>      
                                <div class="col-xl-4 col-lg-6 col-12" v-if="user?.recieve_as_gifts?.length > 0">
                                    <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                        <span class="fw-semibold">Card Gifted From:</span>
                                        <router-link :to="`/users/details/${user?.recieve_as_gifts[0]?.id}`" class="">
                                            {{getSafe(() =>
                                            user?.recieve_as_gifts[0]?.full_name ?? 'N/A')}}
                                        </router-link>
                                    </div>
                                </div>  
                                <template v-if="user?.sent_as_gifts?.length > 0">
                                    <div class="col-xl-4 col-lg-6 col-12">
                                        <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                            <span class="fw-semibold">Card Gifted To:</span>
                                            <router-link :to="`/users/details/${user?.sent_as_gifts[0]?.id}`" class="">
                                                {{getSafe(() =>
                                                user?.sent_as_gifts[0]?.full_name ?? 'N/A')}}
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="col-sm-12" v-if="false">
                                        <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-sm-1">
                                            <span class="fw-semibold">Gifted User Subscription Status:</span>
                                            <span class="" v-if="giftedUserSubscription">{{ isAssociatedOrOwnPurchased }}</span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>


                    <div class="card border border-radius-12">
                        <div class="card-body table mb-0">
                            <div class="row mt-2">
                                <PageHeader title="Subscriptions History" class="poppins fw-normal text-nowrap mt-2" />
                            </div>
                            <UserSubscriptions :showHeading="false" :user="user" />
                        </div>
                    </div>

                    <div class="card border border-radius-12">
                        <div class="card-body table mb-0">
                            <div class="row mt-2">
                                <PageHeader title="Stripe Invoices" class="poppins fw-normal text-nowrap mt-2" />
                            </div>
                            <UserInvoices :showHeading="false" :user="user" />
                        </div>
                    </div>

                    <div class="card border border-radius-12">
                        <div class="card-body table mb-0">
                            <div class="row mt-2">
                                <PageHeader title="Upcoming Invoice" class="poppins fw-normal text-nowrap mt-2" />
                            </div>
                            <UserUpcomingInvoice :showHeading="false" :user="user" />
                        </div>
                    </div>

                    <div class="card border border-radius-12">
                        <div class="card-body table mb-0">
                            <div class="row mt-2">
                                <PageHeader title="Stripe Payments" class="poppins fw-normal text-nowrap mt-2" />
                            </div>
                            <UserPayments :showHeading="false" :user="user" />
                        </div>
                    </div>

                    <div class="card border border-radius-12">
                        <div class="card-body table mb-0">
                            <div class="row mt-2">
                                <div class="col-md-8">
                                    <PageHeader title="Payment Methods" class="poppins fw-normal text-nowrap mt-2" />
                                </div>
                                <div class="col-md-4 d-flex justify-content-center justify-content-sm-end">
                                    <SubmitButton type="button" @clicked="$refs.paymentMethodModal.openModal()"
                                      class="btn btn-primary text-nowrap" defaultClass="btn btn-primary border-0 fw-bold text-white waves-effect waves-light primary-button rounded-pill custom-btn" text="Add Payment Method" :showAddIcon="true" />
                                </div>
                            </div>
                            <UserPaymentMethods ref="userPaymentMethods" :showHeading="false" :user="user" />
                        </div>
                    </div>

                    <div class="card border border-radius-12">
                        <div class="card-body table mb-0">
                            <div class="row mt-2">
                                <PageHeader title="Omaha Black Card Orders" class="poppins fw-normal text-nowrap mt-2" />
                            </div>
                            <UserShipments :showHeading="false" :user="user" />
                        </div>
                    </div>

                    <div class="card border border-radius-12">
                        <div class="card-body table mb-0">
                            <div class="row mt-2">
                                <PageHeader title="User Stripe Events" class="poppins fw-normal text-nowrap mt-2" />
                            </div>
                            <UserStripeEvents :showHeading="false" :user="user" />
                        </div>
                    </div>
                <PaymentMethodModal :user="user" ref="paymentMethodModal" @on-payment-created="$refs.userPaymentMethods.fetchPaymentMethods()" />
                <SwitchPlanModal :user="user" ref="switchPlanModal" @plan-switched="getUserDetails()" />
                <UpdatePasswordModal :user="user" ref="updatePasswordModal" @password-updated="getUserDetails()" />
                </template>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "../../../layouts/static/main";
import PageHeader from "@/components/static/page-header";
import UserSubscriptions from "@/components/general/UserDetails/UserSubscriptions.vue";
import UserInvoices from "@/components/general/UserDetails/UserInvoices.vue";
import UserShipments from "@/components/general/UserDetails/UserShipments.vue";
import UserPayments from "@/components/general/UserDetails/UserPayments.vue";
import UserStripeEvents from "@/components/general/UserDetails/UserStripeEvents.vue";
import UserPaymentMethods from "@/components/general/UserDetails/UserPaymentMethods.vue";
import Swal from "sweetalert2";
import SubmitButton from "@/components/general/SubmitButton.vue";
import PaymentMethodModal from "@/components/general/UserDetails/PaymentMethodModal.vue";
import UserUpcomingInvoice from "@/components/general/UserDetails/UserUpcomingInvoice.vue";
import SwitchPlanModal from "@/components/general/UserDetails/SwitchPlanModal.vue";
import UpdatePasswordModal from "@/components/general/UserDetails/UpdatePasswordModal.vue";

export default {
    name: "UserDetails",
    components: {
        Layout,
        PageHeader,
        UserSubscriptions,
        UserInvoices,
        UserShipments,
        UserPayments,
        UserStripeEvents,
        UserPaymentMethods,
        SubmitButton,
        PaymentMethodModal,
        UserUpcomingInvoice,
        SwitchPlanModal,
        UpdatePasswordModal,
    },
    data() {
        return {
            title: "User Details",
            items: [
                {
                    text: "User Management",
                    href: "/user-management",
                },
                {
                    text: "User Details",
                    href: "/user-details",
                },
            ],
            user: null,
            activeTab: "refresh",
            loading: true,
            cancelbtnprocessing: false,
            user_balance: '$0.00',
            userBalanceProcessing:false,
            statusProcessing: false,
        }
    },
    created() {
        this.getUserDetails();
    },
    computed: {
        filteredTabs() {
            return this.tabs;
        },
        tabs() {
            const subscription = this.user?.subscriptions?.[0] ?? null;
            const hasSubscription = !!subscription;

            const status = (subscription?.stripe_status ?? "").toLowerCase();
            const isCanceled = ["canceled", "cancelled"].includes(status);

            const tabs = [
                { key: "refresh", label: "Refresh Data" },

                ...(hasSubscription
                    ? [{ key: "open_stripe", label: "Open in Stripe" }]
                    : []),

                ...(hasSubscription && !isCanceled
                    ? [{
                        key: "handle_subscription",
                        label: "Handle Subscription",
                        subtabs: [
                            { key: "cancel_subscription", label: "Cancel Subscription" },
                            { key: "switch_subscription", label: "Switch Subscription" },
                        ],
                    }]
                    : []),

                {
                    key: "update_actions",
                    label: "Update",
                    subtabs: [
                        { key: "update_customer", label: "Update Customer" },
                        { key: "update_password", label: "Update Password" },
                    ],
                },
            ];

            return tabs;
        },
        giftedUserSubscription() {
            return this.user?.sent_as_gifts?.[0]?.subscriptions?.[0];
        },
        giftedUserHasPaymentMethodAttached() {
            return this.giftedUser?.pm_type && this.giftedUser?.pm_last_four;
        },
        giftedUser () {
           return this.user?.sent_as_gifts?.[0];
        },
        isAssociatedOrOwnPurchased() {
            if(this.giftedUserSubscription){

                if(this.giftedUserSubscription?.subscription_plan?.name === "Premium" && this.giftedUserSubscription?.stripe_status === "active" && this.giftedUserHasPaymentMethodAttached){
                    return "Gifted user has own subscription.";
                }else if(this.giftedUserSubscription?.subscription_plan?.name === "Free"){
                    return "Gifted user is using a free subscription. This remains active as long as the gifting account keeps its subscription, or until Gifted User purchases their own plan.";
                }else {
                   return this.giftedUserSubscription?.subscription_plan?.name;
                }
            }
            return 'N/A';
        }
    },
    watch: {
        '$route.params.id': {
            immediate: true,
            handler() {
                this.user = null;
                this.getUserDetails();
            }
        }
    },
    methods: {
        getUserDetails() {
            this.loading = true;
            let url = '/single-user-record/' + this.$route.params.id;
            this.$axios.get(url, { params: { with_subscriptions: true,sendAsGifted:true,receivedAsGift:true,with_added_by:true } }).then((response) => {
                this.user = response.data.data;
                this.loading = false;
                this.getUserBalance();
            }).catch((error) => {
                console.log(error.response);
                this.loading = false;
            });
        },
        formatDateTime(isoDate) {
            if (!isoDate) return "N/A";
            const date = new Date(isoDate);
            if (isNaN(date.getTime())) {
                return isoDate;
            }

            const options = {
                year: "numeric",
                month: "short",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
            };

            return date.toLocaleString(undefined, options);
        },
        getSafe(fn, defaultValue = "N/A") {
            try {
                return fn();
            } catch (error) {
                return defaultValue;
            }
        },
        handleImageError(event) {
            event.target.src = require('@/assets/images/placeholder.png');
        },
        setActiveTab(key) {
            if (key == "refresh") {
                this.user = null;
                this.getUserDetails();
            }

            if (key === "open_stripe") {
                if (!this.user || !this.user.stripe_id) return;

                const isTestMode = true;
                const stripeUrl = isTestMode
                    ? `https://dashboard.stripe.com/test/customers/${this.user.stripe_id}`
                    : `https://dashboard.stripe.com/customers/${this.user.stripe_id}`;

                window.open(stripeUrl, "_blank", "noopener");
            }

            if (key === "update_customer") {
                this.$router.push({
                    name: "free-update-user",
                    params: { id: this.$route.params.id },
                });
            }

            if (key === "cancel_subscription") {
                this.cancelSubscription();
            }

            if (key === "switch_subscription") {
                this.switchSubscription();
            }
            if (key === "update_password") {
                if (!this.$refs.updatePasswordModal) {
                    return;
                }
                this.$refs.updatePasswordModal.openModal();
            }
        },
        switchSubscription() {
            this.$refs.switchPlanModal.openModal();
        },
        cancelSubscription() {
            try {
                Swal.fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, Cancel it!",
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        let url = 'subscriptions/cancel-subscription';
                        this.cancelbtnprocessing = true;
                        this.$axios.post(url, { user_id: this.$route.params.id }).then((response) => {
                            this.user = null;
                            this.getUserDetails();
                        }).catch((error) => {
                            this.handleErrorResponse(error.response, "error");
                        }).finally(() => {
                            this.cancelbtnprocessing = false;
                        });
                    }
                });
            } catch (error) {
                this.handleErrorResponse(error.response, "error");
                this.cancelbtnprocessing = false;
            }
        },
        //get user balance from api user-stripe-balance

        getUserBalance() {
            let url = 'user-stripe-balance';
            let params = { user_id: this.user.id }
            this.userBalanceProcessing = true;
            this.$axios.get(url, { params: params }).then((response) => {
                this.user_balance = response.data.data.formatted_balance;
            }).catch((error) => {
                console.log(error.response);
            }).finally(() => {
                this.userBalanceProcessing = false;
            });
        },

        async onToggleUserStatus(e) {
            const nextStatus = e.target.checked ? 1 : 0;

            e.target.checked = !e.target.checked;

            const actionText = nextStatus === 1 ? "activate" : "deactivate";

            const result = await Swal.fire({
                title: `Are you sure?`,
                text: `Do you want to ${actionText} this user?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "Cancel",
            });

            if (!result.isConfirmed) return;

            try {
                this.statusProcessing = true;

                await this.$axios.post("/user/change-status", {
                    id: this.user.id,
                    is_active: nextStatus,
                });

                this.user.is_active = nextStatus;

                Swal.fire({
                    icon: "success",
                    title: "Updated",
                    text: `User ${actionText}d successfully`,
                    timer: 1200,
                    showConfirmButton: false,
                });
            } catch (error) {
                Swal.fire(
                    "Error",
                    error?.response?.data?.message || "Unable to update user status",
                    "error"
                );
            } finally {
                this.statusProcessing = false;
            }
        }
    },
}

</script>

<style scoped>
.inner-parent-bottom-conetent {
    background: #e7e9ea 0 0 no-repeat padding-box;
    box-shadow: 0 5px 10px hsl(0deg 0% 42% / 16%);
}

.nav-tabs .nav-link {
    background-color: #F5F5F5;
    color: var(--dark-grey);
    font-family: "Montserrat", "sans-serif";
    display: flex;
    align-items: center;
    justify-content: center;
}

.user-detail-nav-avatar {
    width: 70px;
    height: 70px;
    border-radius: 50rem !important;
    object-fit: contain;
}
.table > :not(caption) > * > *{
    padding : 0rem 0.75rem;
}
.full-width-mobile {
  width: 100%;
}

@media (min-width: 576px) {
  .full-width-mobile {
    width: auto;
  }
}
@media (max-width: 576px){
  .card-body{
    padding : .25rem .25rem !important;
  }
}

@media (min-width: 1200px) {
  .w-xl-auto {
    width: auto !important;
  }
}

</style>
